
<div class="relative" :class="textfieldClasses">
  <input
    :id="id"
    :ref="refName"
    v-model="content"
    :class="`text-field-input ${hasIcon ? 'pr-56' : 'pr-16'}`"
    :type="type"
    :aria-label="ariaLabel"
    :aria-invalid="hasError"
    :aria-describedby="ariaDescribedByName"
    :required="required"
    :disabled="disabled"
    :readonly="readonly"
    :pattern="pattern"
    :maxlength="maxlength"
    :value="content"
    :inputmode="inputmode"
    :placeholder="placeholder"
    :name="name"
    :autocomplete="autocomplete"
    @keydown.enter.prevent
  />
  <label :class="'pointer-events-none ' + textfieldLabelFilled" :for="id">{{ labelName }}</label>
  <div v-if="hasIcon" class="text-field-icon">
    <slot v-if="(!hasError && !disabled) || iconStatic" name="icon" />
  </div>

  <div v-if="helperText" :id="ariaDescribedByName" class="mt-4 flex relative">
    <ErrorIcon v-if="hasError" class="mr-4 mt-4" />
    <SuccessIcon v-if="isValid" class="mr-4 mt-4" />
    <p class="text-field-helper" v-html="helperText">{{ helperText }}</p>
  </div>
</div>
